import { render, staticRenderFns } from "./deleteCourseModal.vue?vue&type=template&id=38e2f2a0&scoped=true"
import script from "./deleteCourseModal.vue?vue&type=script&lang=js"
export * from "./deleteCourseModal.vue?vue&type=script&lang=js"
import style0 from "./deleteCourseModal.vue?vue&type=style&index=0&id=38e2f2a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e2f2a0",
  null
  
)

export default component.exports